import { Routes, Route, HashRouter } from "react-router-dom";
import ListOdd from "./listOdd";
import Unauthorized from "./unauthorizedPage";
import EmptyPage from "./emptyPage";
import { useEffect } from "react";
import "./App.css"

function App() {

  return (
    <HashRouter>
        <Routes>
         <Route path="/" element={<ListOdd/>}/>
         <Route path="/unauthorized" element={<Unauthorized/>}/>
         <Route path="/empty" element={<EmptyPage/>}/>
      </Routes>
    </HashRouter>
  );
}

export default App;
